import { Link } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import './FolhaDashboard.css'
import { MdKeyboardArrowRight } from "react-icons/md";
import { Select } from "../../select";
import { usePayroll } from "../../../hooks/usePayroll";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { formatValueToMonetary } from "../../../utils/formatter";
import { Pie } from "@antv/g2plot";
import { PageHeader } from "../../page-header";

const statusMap = {
  'DRAFT': 'Rascunho',
  'CALCULATED': 'Calculada',
  'LOCKED': 'Trancada',
  'PAID': 'Paga',
  'CANCELLED': 'Cancelada'
}

const COLORS = {
  'Salários': '#22c55e',
  'Descontos': '#3b82f6',
  'Outros': '#ef4444',
};

export default function () {
  const { user } = useAuth()
  const { payrolls, listPayrolls, getDashboardInfos, dashboardInfos } = usePayroll();
  const [selectedPayroll, setSelectedPayroll] = useState();
  const [avaliableMonths, setAvaliableMonths] = useState([]);

  const containerRef = useRef(null);
  const chartRef = useRef(null);

  const data = [
    { label: 'Salários', value: dashboardInfos?.composition?.net?.amount },
    { label: 'Descontos', value: dashboardInfos?.composition?.benefits?.amount },
    { label: 'Outros', value: dashboardInfos?.composition?.others?.amount },
  ].filter(item => item.value > 0);;

   useEffect(() => {
    if (!containerRef.current) return;

    if (!chartRef.current) {
      chartRef.current = new Pie(containerRef.current, {
        data,
        angleField: "value",
        colorField: "label",
        color: ({ label }) => COLORS[label],
        radius: 0.9,

        legend: false,
        label: false,
        statistic: false,

        tooltip: {
          formatter: (item) => {
            const brl = item.value.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            });
            return { name: item.label, value: brl };
          },
        },

        interactions: [{ type: "element-active" }],
      });

      chartRef.current.render();
    } else {
      chartRef.current.update({ data });
    }
  }, [data]);

  useEffect(() => {
    listPayrolls();
  }, [])

  useEffect(() => {
    if (payrolls && payrolls.length > 0) {
      setAvaliableMonths(payrolls.map(p => {
        return {
          value: p.id,
          label: moment(`${p.referenceYear}-${p.referenceMonth}`).format('MMMM / YYYY')
        }
      }));
      setSelectedPayroll(payrolls[0].id);
    }
  }, [payrolls])

  useEffect(() => {
    if(!selectedPayroll) return;

    const payroll = payrolls?.find(p => p.id === selectedPayroll);
    getDashboardInfos(payroll?.referenceMonth, payroll?.referenceYear);
  }, [selectedPayroll])

  return (
    <div className="dashboard-container">
      <div className="col-md-10">
       <div className="mt-4 mb-3">
          <PageHeader title="Dashboard RH" pages={[{ name: 'Dashboard RH', link: "/folha-pagamento/dashboard" }]} />
        </div>
        <section id="screen-dashboard" className="screen active screen-dashboard">
          <p className="subtitle">Visão consolidada das unidades que utilizam a folha dentro da X-Pay. </p>
          <div className="filters-row">
            <div>
              <Select 
                options={avaliableMonths}
                value={selectedPayroll}
                onChange={setSelectedPayroll}
              />
            </div>
            <div>
              <div className="pill">{dashboardInfos?.payrollStageLabel}</div>
            </div>
          </div>
          <div className="cards-row">
            <div className="dashboard-card">
              <div className="card-title">Total da folha (bruto)</div>
              <div className="card-value">{formatValueToMonetary(dashboardInfos?.summary?.totalGross) || 'R$ 0,00'}</div>
            </div>
            {/* <div className="dashboard-card">
              <div className="card-title">Encargos e impostos</div>
              <div className="card-value">{formatValueToMonetary(dashboardInfos?.summary?.totalCharges) || 'R$ 0,00' }</div>
            </div> */}
            <div className="dashboard-card">
              <div className="card-title">Colaboradores ativos</div>
              <div className="card-value">{dashboardInfos?.summary?.activeCollaborators || '0' }</div>
            </div>
          </div>
          <div>
            <div className="panel">
              <div className="panel-header">
                <div>
                  <div className="panel-title">Composição da folha</div>
                  <div className="panel-subtitle">Percentual de salários, encargos e benefícios.</div>
                </div>
              </div>
              <div className="composition-wrapper">
                <div ref={containerRef} className="composition-chart" style={{ height: 200 }}></div>
                <div className="composition-legend">
                  <div className="legend-item">
                    <span className="legend-color salarios"></span>
                    <span className="legend-label">Salários</span>
                    <span className="legend-percent">
                      {dashboardInfos?.composition?.net?.percentage || '0'}% • {formatValueToMonetary(dashboardInfos?.composition?.net?.amount) || 'R$ 0,00'}
                    </span>
                  </div>
                  {/* <div className="legend-item">
                    <span className="legend-color encargos"></span>
                    <span className="legend-label">Encargos e impostos</span>
                    <span className="legend-percent">
                      {dashboardInfos?.composition?.charges?.percentage}% • {formatValueToMonetary(dashboardInfos?.composition?.charges?.amount) || 'R$ 0,00'}
                    </span>
                  </div> */}
                  <div className="legend-item">
                    <span className="legend-color beneficios"></span>
                    <span className="legend-label">Benefícios (VR, VA, saúde)</span>
                    <span className="legend-percent">
                      {dashboardInfos?.composition?.benefits?.percentage || '0'}% • {formatValueToMonetary(dashboardInfos?.composition?.benefits?.amount) || 'R$ 0,00'}
                    </span>
                  </div>
                  <div className="legend-item">
                    <span className="legend-color outros"></span>
                    <span className="legend-label">Outros</span>
                    <span className="legend-percent">
                      {dashboardInfos?.composition?.others?.percentage || '0'}% • {formatValueToMonetary(dashboardInfos?.composition?.others?.amount) || 'R$ 0,00'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="alerts">
                <div className="alert-item">
                  { dashboardInfos?.payrollStatus === 'DRAFT' && <span className="alert-badge">A folha está em rascunho</span> }
                  { dashboardInfos?.payrollStatus === 'CALCULATED' && <span className="alert-badge">A folha está calculada</span> }
                  { dashboardInfos?.payrollStatus === 'LOCKED' && <span className="alert-badge">A folha está trancada e esperando pagamento</span> }
                  { dashboardInfos?.payrollStatus === 'PAID' && <span className="alert-badge">A folha está paga</span> }
                  { dashboardInfos?.payrollStatus === 'CANCELLED' && <span className="alert-badge">A folha foi cancelada</span> }
                  <span className="alert-badge">Status {statusMap[dashboardInfos?.payrollStatus]}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
